import styled from 'styled-components';

export const Description = styled.div`
  font-family: ${(props) => props.theme.fonts.alt};
  color: ${(props) => props.theme.colors.beige};
  font-size: 1.1rem;
  margin-top: 1.5rem;
  line-height: 1.2;
  text-align: center;
`

export const Logo = styled.img`
  width: 120px;
  display: block;
  margin: 0 auto;
`

export const Binder = styled.div`
  background: #1a1a1a;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 5px rgba(black, 0.2);
  width: 450px;

  @media (max-width: 700px){
    width: 95%;
  }
`

export const BackgroundClose = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0,0,0,0.75);
  opacity: 0;
    
  animation: fadeIn3 1s ease;
  animation-delay: 6s;
  animation-fill-mode: both;


  @keyframes fadeIn3{
    to{
      opacity: 1;
    }
  }

`

export default Wrapper;